export default __webpack_public_path__ + "static/media/scholarship_bursary.42fbd9b3.jpg";